import { render, staticRenderFns } from "./CardCheck.vue?vue&type=template&id=dd50137c"
import script from "./CardCheck.vue?vue&type=script&lang=js"
export * from "./CardCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports